import { accountsVirtualCardsRouteProps } from 'src/navigation/routeProps'
import { createBackgroundReducer } from 'src/redux/genericReducers'
import UsersFullPaginatedDataReducer, {
  Actions as UsersFullPaginatedDataActions,
  initialState as initialUsersFullPaginatedDataState,
  UsersFullPaginatedDataState,
} from 'src/redux/usersFullPaginatedData.reducer'
import VirtualCardsFullPaginatedDataReducer, {
  Actions as VirtualCardsFullPaginatedDataActions,
  initialState as initialVirtualCardsFullPaginatedDataState,
  VirtualCardsFullPaginatedDataState,
} from 'src/redux/virtualCardsFullPaginatedData.reducer'

export interface AccountsVirtualCardsState {
  usersFullPaginatedData: UsersFullPaginatedDataState
  virtualCardsFullPaginatedData: VirtualCardsFullPaginatedDataState
}

export const initialState: AccountsVirtualCardsState = {
  usersFullPaginatedData: initialUsersFullPaginatedDataState,
  virtualCardsFullPaginatedData: initialVirtualCardsFullPaginatedDataState,
}

export type Actions =
  | UsersFullPaginatedDataActions
  | VirtualCardsFullPaginatedDataActions

const CoreAccountsVirtualCardsReducer = (
  state = initialState,
  action: Actions,
): AccountsVirtualCardsState => ({
  usersFullPaginatedData: UsersFullPaginatedDataReducer(
    state.usersFullPaginatedData,
    action as UsersFullPaginatedDataActions,
  ),
  virtualCardsFullPaginatedData: VirtualCardsFullPaginatedDataReducer(
    state.virtualCardsFullPaginatedData,
    action as VirtualCardsFullPaginatedDataActions,
  ),
})

const AccountsVirtualCardsReducer = createBackgroundReducer(
  accountsVirtualCardsRouteProps,
  initialState,
  CoreAccountsVirtualCardsReducer,
)

export default AccountsVirtualCardsReducer
